import * as React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

import Icon from "src/library/components/Icon/Icon";
import { Icons } from "src/library/components/Icon/types";
import { Tooltip } from "src/library/components/Tooltip";
import { Text } from "src/library/components/Text";

interface HelperTextProps {
  /**The inline text that will display  */
  helpText: string;
  /** The explanation text that will show in the tooltip */
  helpExplanation: string;
  /** tippy unique id */
  tippyId: string;
  tipPlace: ReactTooltip.Place;
  className?: string;
}

/**
 * Inline text that when hovered over will display an explanation tooltip
 * @param param0
 * @returns
 */
export const HelperText: React.ReactFCWithChildren<HelperTextProps> = ({
  helpText, helpExplanation, tippyId, className, tipPlace
}) => {
  return (
    <>
      <StyledText
        weight="bold"
        className={className}
      >
        <span
          data-tip
          data-for={tippyId}
        >
          {helpText}

          <Icon
            icon={Icons.HELP}
            size={10}
          />
        </span>
      </StyledText>

      <Tooltip
        id={tippyId}
        type="dark"
        place={tipPlace}
        getContent={() => {
          return (
            <>
              <Text color="white">
                {helpExplanation}
              </Text>
            </>
          );
        }}
      />
    </>
  );
};

const StyledText = styled(Text)`
  text-decoration: underline;

  &:hover {
    cursor: help;
  }
`;
